<template>
  <div>
    <sub-main/>
  </div>
</template>
<script>
import SubMain from '../../canadas/terrenos/maplocation/SubMain'
export default {
  name: "SubMenu",
  components: {
    SubMain
  }
}
</script>
<style scoped>
</style>